var _style, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33.954,
    height: 35.428,
    viewBox: "0 0 43.642 44.804",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{opacity:.6}.st2{clip-path:url(#SVGID_2_);fill:#fff}.st3{opacity:.45}.st4{clip-path:url(#SVGID_4_);fill:#fff}.st5{opacity:.8}.st6,.st7,.st8{clip-path:url(#SVGID_6_);fill:#fff}.st7,.st8{clip-path:url(#SVGID_8_)}.st8{clip-path:url(#SVGID_10_)}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1",
    transform: "matrix(.085782 0 0 -.085782 -61.825 71.087)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "m720.6 306.4h508.7v266h-508.7z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    overflow: "visible",
    xlinkHref: "#SVGID_1_"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m975 306.4-254.4 115.7 254.4 150.3 254.3-150.3z",
    clipPath: "url(#SVGID_2_)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st3",
    transform: "matrix(.085782 0 0 -.085782 -61.825 71.087)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "m720.6 470.3h254.4v358.4h-254.4z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    overflow: "visible",
    xlinkHref: "#SVGID_7_"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "m720.6 470.3 254.4 358.4v-208.1z",
    clipPath: "url(#SVGID_8_)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st5",
    transform: "matrix(.085782 0 0 -.085782 -61.825 71.087)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_9_",
    d: "m975 470.3h254.5v358.4h-254.5z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    overflow: "visible",
    xlinkHref: "#SVGID_9_"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "m975 620.6v208.1l254.5-358.4z",
    clipPath: "url(#SVGID_10_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.515f0d2d.svg";
export { ForwardRef as ReactComponent };